module.exports = __webpack_public_path__ + "img/sg13a-13.prt.750cbd1f.jpg";